import { Component, computed, inject } from '@angular/core';
import { RouterOutlet, TitleStrategy } from '@angular/router';

import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { PboHeader } from '@bo-ui/pinata/header';
import { PboNavigationDrawer, type PboNavigationItemType } from '@bo-ui/pinata/navigation';
import { AmpTitleStrategy } from '../amp-title.strategy';
import { AMP_APP_SHELL_CONFIG } from '../provide-app-shell';
import { SHELL } from '../test-ids';

@Component({
  selector: 'amp-app-shell',
  templateUrl: './app-shell.component.html',
  styleUrl: './app-shell.component.scss',
  host: {
    '[attr.data-testid]': 'testIds.ROOT',
  },
  imports: [PboHeader, PboNavigationDrawer, RouterOutlet, TranslocoPipe],
})
export class AmpAppShell {
  readonly config = inject(AMP_APP_SHELL_CONFIG);
  readonly testIds = SHELL;
  readonly pageTitleKey = computed(() => {
    if (!(this.#titleStrategy instanceof AmpTitleStrategy)) {
      return undefined;
    }

    return this.#titleStrategy.routeTitleKey();
  });
  readonly navItems = computed<PboNavigationItemType[]>(() => {
    const lang = this.#transloco.activeLang();

    return this.config.nav.map((item) => ({
      label: this.#transloco.translate(item.labelKey, {}, lang),
      link: item.link,
      testId: item.testId,
      fontIcon: item.fontIcon ?? 'home',
    }));
  });
  readonly #titleStrategy = inject(TitleStrategy);
  readonly #transloco = inject(TranslocoService);
}
